import React from 'react'
import { cn } from 'src/lib/utils'

interface SeriesCardBadgeInProgressProps {
  className?: string
}

export const SeriesCardBadgeInProgress = ({ className }: SeriesCardBadgeInProgressProps): React.ReactElement => {
  return (
    <div className={cn('inline-flex shrink-0 items-center gap-2 rounded-full bg-success px-2 py-1 text-ivory', className)}>
      <span className="h-2 w-2 shrink-0 rounded-full bg-ivory" aria-hidden />
      <span className="text-xs font-roboto-condensed-medium capitalize tracking-wide">In progress</span>
    </div>
  )
}
